import { useEffect } from 'react';
import { TsoRegistrationContact } from 'src/apis/shipper-registration/types';
import { isServerError, useAxios } from 'src/hooks/use-axios';
import urlTemplate from 'url-template';

type Options = {
  tsoId: string;
  url: string;
};

export function useTsoRegistrationContact({ tsoId, url }: Options) {
  const registrationData = useAxios(
    (axios, signal) =>
      axios.request<TsoRegistrationContact>({
        signal,
        url: urlTemplate.parse(url).expand({ tsoId }),
        method: 'GET',
      }),
    {
      neededOnPageLoad: true,
      onError(error) {
        // 404 in case no registration contact was created, yet
        if (isServerError(error, 404)) return error;
        throw error;
      },
    }
  );

  useEffect(() => {
    registrationData.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return registrationData;
}

export type TsoRegistrationContactRequest = ReturnType<
  typeof useTsoRegistrationContact
>;
